import { IUser } from "../interfaces/user";
import api from "./api";

const pageSize = 5;


export async function fetchUser(
  pageNumber: number,
  search: string
): Promise<any> {
  let url = "";
  const params: any = { page: pageNumber, pageSize };

  if (search.trim()) {
    url = `/User/searchUserbyname`;
    params.name = search;
  } else {
    url = `/User/paged`;
  }

  const response = await api.get(url, { params });
  return response;
}

export async function saveUser(
  data: IUser,
  editando: boolean,
  userId?: number
) {
  const dataToSend = { ...data, foto: null, userId: 1 };
  if (editando && userId) {
    dataToSend.id = userId;
    return api.put(`User/`, dataToSend);
  } else {
    return api.post(`User/`, dataToSend);
  }
}

export async function deleteUser(userId: number) {
  return api.delete(`User/${userId}`);
}
